import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { Product } from '../models/Product';

export default class ProductStore {
    productRegistry = new Map<number, Product>();
    loadingInitial = false;
    page = 1;
    hasNext = false;
    totalCount = 0;
    mappedCount = 0;
    searchTerm = '';
    hasFitmentFilter = '';
    vendorFilter = '';
    tagFilter = '';
    sort = 'title asc';
    yearFilter = '';
    yearToFilter = '';
    makeFilter = '';
    modelFilter = '';
    mappedOnlyFilter = false;
    fieldValueFilters: Record<string, string> = {};

    constructor() {
        makeAutoObservable(this);
    }

    get products() {
        return Array.from(this.productRegistry.values());
    }

    loadProducts = async (
        page: number = 1,
        query: string = this.searchTerm,
        hasFitment: string = this.hasFitmentFilter,
        vendor: string = this.vendorFilter,
        tag: string = this.tagFilter,
        sort: string = this.sort,
        year: string = this.yearFilter,
        yearTo: string = this.yearToFilter,
        make: string = this.makeFilter,
        model: string = this.modelFilter,
        mappedOnly: boolean = this.mappedOnlyFilter,
        fieldValues: Record<string, string> = this.fieldValueFilters
    ) => {
        this.loadingInitial = true;
        try {
            const result = await agent.Products.list(page, query, hasFitment, vendor, tag, sort, year, yearTo, make, model, mappedOnly, fieldValues);
            runInAction(() => {
                this.productRegistry.clear();
                result.products.forEach(product => {
                    this.productRegistry.set(product.id, product);
                });
                this.hasNext = result.hasNext;
                this.totalCount = result.totalCount ?? 0;
                this.mappedCount = result.mappedCount;
                this.page = page;
                this.searchTerm = query;
                this.hasFitmentFilter = hasFitment;
                this.vendorFilter = vendor;
                this.tagFilter = tag;
                this.sort = sort;
                this.yearFilter = year;
                this.yearToFilter = yearTo;
                this.makeFilter = make;
                this.modelFilter = model;
                this.mappedOnlyFilter = mappedOnly;
                this.fieldValueFilters = { ...fieldValues };
                this.loadingInitial = false;
            });
        } catch (error) {
            console.log(error);
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    clearProducts = () => {
        this.productRegistry.clear();
        this.page = 1;
        this.hasNext = false;
        this.searchTerm = '';
        this.hasFitmentFilter = '';
        this.vendorFilter = '';
        this.tagFilter = '';
        this.sort = 'title asc';
        this.mappedCount = 0;
        this.yearFilter = '';
        this.yearToFilter = '';
        this.makeFilter = '';
        this.modelFilter = '';
        this.mappedOnlyFilter = false;
        this.fieldValueFilters = {};
    }
}
